import { heroBannerInit } from "@/helpers/builder-init/HeroBanner";
import { bannerFeaturedContentInit } from "@/helpers/builder-init/BannerFeaturedContent";
export const registeredComponents = [
    heroBannerInit,
    bannerFeaturedContentInit,
]
